import { Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { FontIconComponent } from '@camelot/icons';

import { GridRow } from '../../../../services/dto/grid-row';

type SelectedRowParams = ICellRendererParams & { selectedIcon?: string };

@Component({
  host: { 'data-cid': 'editabled-selected-row' },
  imports: [FontIconComponent],
  selector: '',
  styleUrl: './editabled-selected-row.component.scss',
  templateUrl: './editabled-selected-row.component.html',
})
export class EditabledSelectedRowComponent implements ICellRendererAngularComp {
  public data: GridRow | null = null;
  public selectedIcon: string = 'clockwise-2-line';

  agInit(params: SelectedRowParams): void {
    this.data = (params.data ?? null) as GridRow | null;
    this.selectedIcon = params.selectedIcon ?? 'clockwise-2-line';
  }

  refresh(params: SelectedRowParams): boolean {
    this.agInit(params);
    return true;
  }
}
